import Api from ".";
import { DEVURL, AZUREURL, SITURL, PRODURL } from "./envUrl";

export const getProjectPlan = async (
  projectId,
  payLoad,
  headers = {
    "Access-Control-Allow-Headers": "Content-Type",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "OPTIONS,POST,GET",
  }
) => {
  const api = new Api();
  const axiosInstance = await api.init({ headers });
  let apiURL = `${DEVURL}/projectplan/${projectId}`;
  try {
    const response = await axiosInstance({
      url: apiURL,
      method: "POST",
      data: payLoad,
    });
    // Check for successful response status, e.g., 200 OK
    if (response?.status === 200) {
      const projectPlanData = response?.data?.ArtworkAgilityProjects;
      const reworkHistoryData = response?.data?.ReasonForReworkList;
      const AccessType = response?.data?.AccessType;
      const specialProject = response?.data?.SpecialProject;
      const rejectionReasons = response?.data?.RejectionReasons;
      const datePopulated = response?.data?.IsDatePopulated;

      // return projectPlanData;
      return {
        projectPlanData,
        reworkHistoryData,
        projectState: response?.data?.ProjectState,
        responseStatus: response?.status,
        AccessType,
        specialProject: specialProject,
        rejectionReasons,
        datePopulated
      };
    }
  } catch (error) {
    if (error.message.includes("net::ERR_CONNECTION_TIMED_OUT")) {
      // Handle the server being down
      return { error: "The server is currently unavailable. Please try again later." };
    } else {
      console.error("Error fetching project plan:", error);
      throw error; // Rethrow the error for other types of errors
    }
  }
};

export const getRolesOwners = async (projectId, headers = {}) => {
  const api = new Api();
  const axiosInstance = await api.init({ headers });
  let apiURL = `${DEVURL}/rolesAndOwnersList/${projectId}`;
  try {
    const response = await axiosInstance({
      url: apiURL,
      method: "GET",
    });
    // Check for successful response status, e.g., 200 OK
    if (response?.status === 200) {
      // Transform new API structure to match existing code expectations
      const data = response?.data?.ArtworkAgilityProjects || response?.data;
      const rolesOwnersData = transformRolesOwnersData(data);
      
      return { rolesOwnersData, responseStatus: response?.status };
    } else {
      
      return { rolesOwnersData: [], responseStatus: response?.status };
    }
  } catch (error) {
    
    if (error.message.includes("net::ERR_CONNECTION_TIMED_OUT")) {
      // Handle the server being down
      return { error: "The server is currently unavailable. Please try again later." };
    } else {
      
      return { rolesOwnersData: [], responseStatus: 500, error: error.message };
    }
  }
};

const transformRolesOwnersData = (data) => {
 
  if (!Array.isArray(data) || data.length === 0) {
  
    return [];
  }
  
  // Check if data already has the old structure (with RolesList)
  if (data[0]?.RolesList) {
    
    return data;
  }
  
  // Transform new flattened structure to match internal expectations
  // If API provides TaskID/Code, create separate entries; otherwise create global entry
  if (data[0]?.TaskID || data[0]?.Code) {
    return data.map(item => ({
      TaskID: item.TaskID || "global",
      Code: item.Code || "global_code",
      RolesList: [{
        Role: item.Role,
        OwnerList: (item.OwnerList || [])
          .map(owner => ({
            Person: owner.Person,
            pyName: owner.pyName,
            Rank: owner.Rank
          }))
          .sort((a, b) => (a.Rank || 999) - (b.Rank || 999))
      }]
    }));
  }

  
  const rolesList = data.map(item => ({
    Role: item.Role,
    OwnerList: (item.OwnerList || [])
      .map(owner => ({
        Person: owner.Person,
        pyName: owner.pyName,
        Rank: owner.Rank
      }))
      .sort((a, b) => (a.Rank || 999) - (b.Rank || 999))
  }));

  const result = [{
    TaskID: "global",
    Code: "global",
    RolesList: rolesList
  }];
  
  return result;
};

export const activateProjectPlan = async (formData, projectId, headers = {}) => {
  const api = new Api();
  const axiosInstance = await api.init({ headers });
  let apiURL = `${DEVURL}/activateProject/${projectId}`;
  const activateResponse = await axiosInstance({
    url: apiURL,
    method: "POST",
    data: formData,
  });
  return activateResponse;
};

export const createNewAzureFolder = async (projectName, projecId, BU, headers = {}) => {
  const api = new Api();
  const axiosInstance = await api.init({ headers });
  const folderStructure = `/${projectName}-${projecId}/${BU}/`;
  
  let apiURL = `${AZUREURL}/createFolders?path=${folderStructure}`;
  const activateResponse = await axiosInstance({
    url: apiURL,
    method: "POST",
  });
  return activateResponse;
};

export const saveProjectPlanAction = async (formData, id, headers = {}) => {
  const api = new Api();
  const axiosInstance = await api.init(headers);
  let apiURL;
  apiURL = `${DEVURL}/saveproject/${id}`;

  const saveProjectPlanActionData = await axiosInstance({
    url: apiURL,
    method: "POST",
    data: formData,
  });
  return saveProjectPlanActionData;
};

export const storeApproveFileDetails = async (formData, id, headers = {}) => {
  const api = new Api();
  const axiosInstance = await api.init(headers);
  let apiURL;
  apiURL = `${DEVURL}/storeApproveFileDetails/${id}`;

  const storedFileDetails = await axiosInstance({
    url: apiURL,
    method: "POST",
    data: formData,
  });
  return storedFileDetails;
};


export const cancelTask = async (TaskID,projectID,headers = {}) => {
  if(TaskID !== undefined || projectID !== undefined) {
    
      headers = {
        "Access-Control-Allow-Headers": "Content-Type",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "OPTIONS,POST,GET",
      }
      const api = new Api();
      const axiosInstance = await api.init({ headers });
      let apiURL;
      apiURL = `${DEVURL}/cancelAWMTask?AWMProjectID=${projectID}&AWMTaskID=${TaskID}`;

      const cancelProjectTaskData = await axiosInstance({
        url: apiURL,
        method: "POST",
        data: null,
      });
      
      return cancelProjectTaskData;
  }    
};

export const saveProjectsFromDashboard = async (formData, headers = {}) => {
  const api = new Api();
  const axiosInstance = await api.init({ headers });
  let apiURL = `${DEVURL}/saveProjectsFromDashboard`;

  const saveProjectsResponse = await axiosInstance({
    url: apiURL,
    method: "PUT",
    data: formData,
  });
  return saveProjectsResponse;
};